import React, { Component, Fragment, useRef } from "react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

import i18n from "../../../../i18n";
import Select2 from "../../../utilities/Form/Select2";
import { Button, Table } from "react-bootstrap";
import cookieManager from "../../../../utils/cookieManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import SalesInvoiceReportMiddleware from "../../../../middleware/modules/report/sales-report";
import ReportSelling from "./selling-report";

const MySwal = withReactContent(Swal);
export class PriceComparisonSelling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arr: null,
      listData: null,
      fill: 0,
      bound: 0,
      search: '',
      idSupplier: null,
      supplierList: [],
      supplierText: 'All',
      supplierCurrent: null,
      idBranch: null,
      branchCurrent: null,
      branchText: i18n.t("All"),
      branchList: [],
      itemCurrent: null,
      itemText: i18n.t("All"),
      itemList: [],
      loadingStore: false,
      loadingCustomer: false,
      idStore: null,
      storeCurrent: null,
      storeText: i18n.t("Select Store"),
      storeList: [],
      idCustomer: null,
      customerCurrent: null,
      customerText: i18n.t("All"),
      customerList: [],
      date: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      progressConvert: false,
      showData: false,
      showDataDetail: false,
      transactionList: null,
      orderList: null,
      loadingData: false,
      loadingDataDetail: false,
      idSO: null,
      show: 0
    }
    this.handlerSelect = this.handlerSelect.bind(this);
    this.handlerDateTime = this.handlerDateTime.bind(this);
    this.updateShow = this.updateShow.bind(this);
    this.backPage = this.backPage.bind(this);
    this.updateShowDetail = this.updateShowDetail.bind(this);
  }
  renderError(name) {
    const { isError, errorMessage } = this.props;
    var value = "";
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0];
      }
    }
    return i18n.t(value);
  }
  handlerSelect(e, name, currentState) {
    var key = name;
    var value = null;
    if (e != null) {
      value = e.value;
    }
    this.setState({
      [key]: value,
      [currentState]: e,
    }
    );
  }

  updateShow(newShow, id) {
    this.setState({ showDataDetail: newShow, showData: false, idSO: id, loadingData: true }, () => this.getDataDetail('getTransaction'));
  }

  backPage(back) {
    this.setState({ showDataDetail: false, showData: back });
  }

  updateShowDetail(newShow, id) {
    this.setState({ showDataDetail: newShow, idPO: id, loadingDataDetail: true }, () => this.getDataDetail('getOrder'));
  }
  getDataDetail(type, extra = () => { }) {
    const token = cookieManager.getUserToken();
    let params = null;
    let fill = null;
    let method = null;
    switch (type) {
      case "getTransaction":
        fill = "transactionList";
        method = "POST";
        var url = process.env.REST_URL + 'report/tracking-sales-full';
        var idSO = this.state.idSO != undefined
          ? this.state.idSO
          : null;
        params = {
          idSO: idSO,
        }


        break;
      case "getOrder":
        fill = "orderList";
        method = "POST";
        var url = process.env.REST_URL + 'report/tracking-purchasing-po';
        var branch =
          this.state.branchCurrent != undefined
            ? this.state.branchCurrent.value
            : null;
        var supplier = this.state.idSupplier != undefined
          ? this.state.idSupplier
          : null;
        var po = this.state.idPO != undefined
          ? this.state.idPO
          : null;
        var startDate = moment(this.state.startDate).format('YYYY-MM-DD');
        var endDate = moment(this.state.endDate).format('YYYY-MM-DD');

        if (branch != null) {
          params = {
            idBranch: branch,
            idSupplier: supplier,
            startDate: startDate,
            endDate: endDate,
            idPO: po,
          };
        }


        break;
    }

    switch (method) {
      case "POST":
        axios({
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${SalesInvoiceReportMiddleware.getToken()}`
          },
          url: url,
          data: params,
          responseType: 'json'
        })
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              this.setState({ [fill]: response.data.result, loadingData: false, loadingDataDetail: false }, extra);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        break;
      case "GET":
        axios({

          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TrackingPurchasingMiddleware.getToken()}`
          },
          url: url,
          params: params,
          responseType: 'json'
        })
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              this.setState({ [fill]: response.data.result, loadingData: false, loadingDataDetail: false }, extra);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        break;
    }
  }

  getData(type, extra = () => { }) {
    const token = cookieManager.getUserToken();
    let params = null;
    let fill = null;
    switch (type) {
      case "getStore":
        fill = "storeList";
        var url = process.env.REST_URL + "helper/get-store";
        var branch =
          this.state.branchCurrent != undefined
            ? this.state.branchCurrent.value
            : null;
        if (branch != null) {
          params = {
            id: branch,
          };
        }

        break;
      case "getCustomer":
        fill = "customerList";
        var url = process.env.REST_URL + "helper/get-customer";
        var branch =
          this.state.branchCurrent != undefined
            ? this.state.branchCurrent.value
            : null;
        var store =
          this.state.storeCurrent != undefined
            ? this.state.storeCurrent.value
            : null;
        if (branch != null || store != null) {
          params = {
            branch: branch,
            store: store,
          };
        }

        break;
    }

    if (type != null && params != null) {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        url: url,
        responseType: "json",
        params: params,
      })
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            this.setState({ [fill]: response.data.result }, extra);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
  handlerDateTime(e, name) {
    var key = name;
    var value = e
    this.setState({
      [key]: value
    })
  }

  renderLoading() {
    Swal.fire({
      title: 'Loading',
      width: "200px",
      heightAuto: true
    });
    Swal.showLoading();
  }
  alertHandler(title, message, icon) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }
  async convertExcel() {
    if (this.state.employeeCurrent != null) {
      this.setState({ progressConvert: true })

      const params = {
        date: moment(this.state.date).format('YYYY-MM-DD'),
        idEmployee: this.state.idEmployee,
      }

      var salesName = this.state.employeeCurrent?.label
      var nameFile = 'Report Visiting ' + (moment(this.state.date).format('DD MM YYYY')) + ' Sales ' + salesName;

      this.renderLoading();
      const token = cookieManager.getUserToken();
      axios({
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: process.env.REST_URL + "sales/report-visit-excel",
        method: "GET",
        params: params,
        responseType: "blob",
      }).then((response) => {
        if (response && response.status === 200 && response.data) {
          Swal.close();
          this.setState({ progressConvert: false })
          this.alertHandler('Convert Excel', 'Download Successfully', 'success')
          var urlCreator = window.URL || window.webkitURL;
          const blobUrl = urlCreator.createObjectURL(response.data);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = blobUrl;
          link.setAttribute("download",
            nameFile + '.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          Swal.close();
        }
      }).catch((error) => {
        this.setState({ progressConvert: false })
        this.alertHandler('Convert Excel', 'Internal Server Error', 'info')
      });
    }

  }

  showTracking() {
    const post = {
      idItem: this.state.itemCurrent ? this.state.itemCurrent.value : '',
      idBranch: this.state.branchCurrent ? this.state.branchCurrent.value : '',
    }

    this.props.getDataSelling(post)
  }

  handlerSearch(e) {
  const value = e.target.value;
  const originalData = this.state.listData;

  if (value !== "") {
    const valueLower = value.toLowerCase();

    const updateList = this.state.arr.map(branch => {
      const isBranchMatch = branch.name?.toLowerCase().includes(valueLower);

      const filteredTypes = branch.type.map(type => {
        const isTypeMatch = type.name?.toLowerCase().includes(valueLower);

        const filteredItems = type.item.filter(itm =>
          itm.name_item?.toLowerCase().includes(valueLower) ||
          itm.code?.toLowerCase().includes(valueLower) ||
          itm.brand?.toLowerCase().includes(valueLower) ||
          itm.category?.toLowerCase().includes(valueLower) ||
          itm.unit?.toLowerCase().includes(valueLower) ||
          itm.date?.toLowerCase().includes(valueLower) ||
          itm.price?.toLowerCase().includes(valueLower)
        );

        if (isTypeMatch || filteredItems.length > 0) {
          return {
            ...type,
            item: isTypeMatch ? type.item : filteredItems,
          };
        }

        return null;
      }).filter(Boolean);

      if (isBranchMatch || filteredTypes.length > 0) {
        return {
          ...branch,
          type: isBranchMatch ? branch.type : filteredTypes,
        };
      }

      return null;
    }).filter(Boolean);

    this.setState({
      bound: 1,
      search: value,
      listData: updateList,
    });
  } else {
    this.setState({
      fill: 1,
      search: '',
      bound: 0,
      listData: originalData,
    });
  }
}

  // handlerSearch(e) {
  //   var value = e.target.value;
  //   let data = this.state.listData
  //   var updateList = [...this.state.arr];

  //   if (value != "") {

  //     const valueLower = value.toLowerCase();

  //     const updateList = this.state.arr.map(branch => {
  //       const isBranchMatch = branch.name?.toLowerCase().includes(valueLower);
  //       // const isTypeMacth = 
  //       const filteredItems = branch.type.filter(itm =>
  //         itm.name.toLowerCase().includes(valueLower)
  //       );

  //       if (isBranchMatch) {
  //         return {
  //           ...branch,
  //           type: branch.type
  //         };
  //       }else if (filteredItems.length > 0) {
  //         return {
  //           ...branch,
  //           type: filteredItems
  //         };
  //       }

  //       return null;
  //     }).filter(branch => branch !== null);

  //     this.setState({
  //       bound: 1,
  //       search: value,
  //       listData: updateList,
  //     });
  //   } else {
  //     this.setState({
  //       fill: 1,
  //       search: '',
  //       bound: 0,
  //       listData: data
  //     });
  //   }
  // }

  render() {
    const { helper, isProcessing, dataSelling } = this.props;
    let arr = [];
    if (helper != null && helper != undefined) {
      this.state.branchList = helper.branch;
      this.state.itemList = helper.item;
    }

    if (dataSelling.data != null && dataSelling.data != undefined) {
      this.state.arr = dataSelling.data
      if (this.state.bound == 0) {
        this.state.fill = 0
      }
    }

    if (this.state.fill == 0 && this.state.arr != undefined) {
      this.state.listData = this.state.arr
      this.state.fill = 1;
    }

    return (
      <div className="card-body pt-3">
        <div className="row mb-4">
          <div className="col-sm-3">
            <Select2
              isClearable={true}
              name={"idBranch"}
              required={true}
              onChange={async (e) => {
                if (e != this.state.branchCurrent) {
                  await this.handlerSelect(
                    e,
                    "idBranch",
                    "branchCurrent"
                  );
                }
              }}
              options={this.state.branchList}
              title={i18n.t("Branch")}
              value={this.state.branchCurrent}
              currentState={"branchCurrent"}
              placeholder={this.state.branchText}
            />
          </div>
          <div className="col-sm-3">
            <Select2
              isClearable={true}
              name={"idItem"}
              required={true}
              onChange={async (e) => {
                if (e != this.state.itemCurrent) {
                  await this.handlerSelect(
                    e,
                    "idItem",
                    "itemCurrent"
                  );
                }
              }}
              options={this.state.itemList}
              title={i18n.t("Item")}
              value={this.state.itemCurrent}
              currentState={"itemCurrent"}
              placeholder={this.state.itemText}
            />
          </div>

          <div className="row align-items-center mb-4">
            <div className="col-sm-6 d-flex justify-content-start">
              <Button
                onClick={(e) => {
                  this.setState({ showData: true, showDataDetail: false });
                  this.showTracking();
                }}
                variant="success"
                className="btn btn-md btn btn-success mt-8 "
              >
                {isProcessing ?
                  <span className="indicator-progress " >{i18n.t("Please wait")}...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                  :
                  <span className="indicator-label"><FontAwesomeIcon icon={faEye}></FontAwesomeIcon> {i18n.t("Show")}</span>
                }

              </Button>
              <button className="btn btn-md dropdown-toggle btn-secondary mt-8 " style={{ marginLeft: '10px' }} type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {i18n.t("Convert ")}
              </button>
              <div className="dropdown-menu dropdown-menu-area" aria-labelledby="dropdownMenuButton">
                <a className="dropdown-item"
                  href={"/report/price-comparison/print/selling/" + (
                    this.state.branchCurrent != null ? this.state.branchCurrent.value : 'all') + "/" +
                    (this.state.itemCurrent != null ? this.state.itemCurrent.value : 'all')
                  } target="_blank">
                  <FontAwesomeIcon icon={faFilePdf}></FontAwesomeIcon>  {i18n.t("PDF")}</a>
                {/* <a className="dropdown-item " href="#" onClick={()=>this.convertExcel()}><FontAwesomeIcon icon={faFileExcel}></FontAwesomeIcon>  {i18n.t("Excel")} </a> */}

              </div>

            </div>
            <div className="col-sm-6 d-flex justify-content-end">
              {this.state.showData ?
                <Fragment>
                  <div className="col-md-4 mt-3 ">
                    <input
                      type={"text"}
                      className="form-control form-control-md justify-content-right"
                      placeholder="Search"
                      name={"search"}
                      title={""}
                      value={this.state.search}
                      onChange={(e) => this.handlerSearch(e)}
                    />
                  </div>
                </Fragment>
                : null
              }

            </div>
          </div>
        </div>
        {this.state.listData != undefined && this.state.showData ?
          <Fragment>
            <div className="row">
              <ReportSelling
                {...this.props}
                arr={this.state.listData}
                updateShow={this.updateShow}
              ></ReportSelling>
            </div>
          </Fragment>
          : null}
      </div>
    );
  }
}

export default PriceComparisonSelling;
